<template>
	<ws-pill type="info" class="ml-2" v-if="impersonatedUser">
		<ws-icon icon="user" />
		{{ impersonatedUser.email }}
		<ws-icon icon="on" class="is-clickable" @click="endImpersonation" />
	</ws-pill>
</template>
<script lang="ts" setup>
import { useImpersonation } from "@/composables/useImpersonation";

const { impersonatedUser, endImpersonation } = useImpersonation();
</script>
<style lang="scss" scoped>
.ws-pill {
	gap: 0.5rem;
}
</style>
